<template>
  <div>
    <div class="home-hero-container container">
      <div class="home-hero">
        <div
          id="J_homeSwiper"
          class="swiper-container home-hero-swiper swiper-no-swiping swiper-container-fade swiper-container-initialized swiper-container-horizontal"
        >
          <el-carousel trigger="click" height="460px">
            <el-carousel-item
              v-for="(item, index) in hero.home_slider"
              :key="index"
            >
              <a target="_blank" :href="item.link">
                <el-image :src="item.image" fit="cover"></el-image>
              </a>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="home-hero-sub row">
          <div class="span4">
            <ul class="home-channel-list clearfix">
              <li v-for="(item, index) in hero.channel_list" :key="index">
                <a target="_blank" :href="item.link"
                  ><img :src="item.image" :alt="item.name" />
                  {{ item.name }}
                </a>
              </li>
            </ul>
          </div>
          <div class="span16">
            <ul id="J_homePromoList" class="home-promo-list clearfix">
              <li
                :class="{ first: index == 0 }"
                v-for="(item, index) in hero.promo_list"
                :key="index"
              >
                <a target="_blank" :href="item.link"
                  ><img :src="item.image" alt=""
                /></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { api, session } from "@/assets/js/util.js";
export default {
  name: "HomeHero",
  data() {
    return {
      hero: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let that = this;
      let hero = session.get("hero");
      if (!hero === true) {
        api.get("hero").then(function(res) {
          if (res.code) {
            console.log(res.data);
            session.set("hero", res.data);
            that.hero = session.get("hero");
          }
        });
      } else {
        that.hero = session.get("hero");
      }
    },
  },
};
</script>
<style>
.el-carousel__arrow.el-carousel__arrow--left {
  border-radius: 2px !important;
  left: 244px;
  font-size: 32px;
  height: 68px;
  background: #000;
  opacity: 0.38;
}
.el-carousel__arrow.el-carousel__arrow--right {
  border-radius: 2px !important;
  font-size: 32px;
  height: 68px;
  right: 10px;
  background: #000;
  opacity: 0.38;
}
</style>
